import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { deleteTodo, toggleStateTodo } from "../../redux/modules/TodosSlice";

function Todo({ doList }) {
     const dispatch = useDispatch();

     const onDelHandler = (del) => {
          dispatch(deleteTodo(del));
     };

     const onEditHandler = (edit) => {
          dispatch(toggleStateTodo(edit));
     };

     return (
          <ListTodo>
               <STupside>
                    <Link to={`/Detail/${doList.id}`} className="link">
                         상세보기
                    </Link>
               </STupside>
               <h3>{doList.title}</h3>
               <p>{doList.body}</p>
               <div>
                    <Btn onClick={() => onDelHandler(doList.id)}>삭제하기</Btn>
                    <Btn onClick={() => onEditHandler(doList.id)}>
                         {doList.isDone ? "취소" : "완료"}
                    </Btn>
               </div>
          </ListTodo>
     );
}

export default Todo;

const ListTodo = styled.div`
     width: 450px;
     min-width: 450px;
     height: 330px;
     border: 7px solid steelblue;
     border-radius: 20px;
     display: flex;
     flex-direction: column;
     justify-content: space-between;
     padding: 35px;
     font-size: 20px;
     h3 {
          height: 20%;
          padding: 5px;
     }
     p {
          height: 40%;
          padding: 5px;
     }
     div:last-child {
          width: 100%;
          display: flex;
          justify-content: space-between;
     }
`;

const STupside = styled.div`
     width: 100%;
     height: 40px;
     display: flex;
     justify-content: end;
     .link {
          text-decoration: none;
          color: steelblue;
          font-weight: 600;
          font-size: 18px;
     }
`;

const Btn = styled.button`
     width: 45%;
     height: 50px;
     background-color: steelblue;
     border: transparent;
     border-radius: 10px;
     font-size: 16px;
     color: white;
     font-weight: 700;
     cursor: pointer;
     :last-child {
          width: 45%;
          background-color: white;
          border: transparent;
          border-radius: 10px;
          font-size: 16px;
          border: 4px solid steelblue;
          color: steelblue;
     }
`;
